import { Answers, BikeAdapterProduct } from '../Types/Types.ts';

const normalize = (value: unknown): string =>
  String(value ?? '')
    .trim()
    .toLowerCase();

const getAxleType = (row: BikeAdapterProduct): string => {
  const raw = normalize(row.FitsAxleType);
  if (raw.includes('thru')) {
    return 'thru';
  }
  if (raw.includes('solid')) {
    return 'solid';
  }
  if (raw.includes('qr skewer')) {
    return 'qr';
  }
  return raw;
};

const getThread = (row: BikeAdapterProduct): string => row.ThreadSize.trim();

const productsForAnswerPath = (products: BikeAdapterProduct[], answers: Answers): BikeAdapterProduct[] => {
  let filtered = products;
  if (answers.axleType) {
    filtered = filtered.filter((product) => getAxleType(product) === answers.axleType);
  }
  if (answers.thread) {
    filtered = filtered.filter((product) => normalize(getThread(product)) === normalize(answers.thread));
  }
  return filtered;
};

const productsForSelectedAnswers = (products: BikeAdapterProduct[], answers: Answers): BikeAdapterProduct[] => {
  const filtered = productsForAnswerPath(products, answers);
  if (!answers.length) {
    return filtered;
  }

  return filtered.filter((product) => {
    const productLength = answers.coneType === 'coned' ? product.ThruAxleLengthConed : product.ThruAxleLengthFlat;
    return normalize(productLength) === normalize(answers.length);
  });
};

export { getThread, productsForAnswerPath, productsForSelectedAnswers };
